import { render, staticRenderFns } from "./cloudEditConfirm.vue?vue&type=template&id=874c23fe&scoped=true&"
import script from "./cloudEditConfirm.vue?vue&type=script&lang=js&"
export * from "./cloudEditConfirm.vue?vue&type=script&lang=js&"
import style0 from "./cloudEditConfirm.vue?vue&type=style&index=0&id=874c23fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "874c23fe",
  null
  
)

component.options.__file = "cloudEditConfirm.vue"
export default component.exports